/**
 * SEO 유틸리티 함수들
 * 페이지별 타이틀과 메타 description 설정
 */

export const setPageTitle = (title: string) => {
  document.title = `${title} | 굿타임 렌터카`;
};

export const setPageMeta = (description: string) => {
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', description);
  }
};

export const setOgMeta = (title: string, description: string, url?: string) => {
  const ogTitle = document.querySelector('meta[property="og:title"]');
  const ogDescription = document.querySelector('meta[property="og:description"]');
  const ogUrl = document.querySelector('meta[property="og:url"]');

  if (ogTitle) {
    ogTitle.setAttribute('content', title);
  }
  if (ogDescription) {
    ogDescription.setAttribute('content', description);
  }
  if (ogUrl && url) {
    ogUrl.setAttribute('content', url);
  }
};

// 페이지별 SEO 설정
export const pageSEO = {
  home: {
    title: '부산 렌터카 | 부산 서면 렌트카 | 굿타임 렌터카 – 믿고 타는 렌트카',
    description: '부산 서면 중심 위치, 철저한 차량 관리, 24시간 예약 가능. 부산 렌트카는 굿타임에서 편리하게 이용하세요.',
  },
  search: {
    title: '부산 렌트카 차량 검색 - 부산 서면 렌터카',
    description: '부산 렌터카 차량 검색 및 비교. 다양한 차종, 합리적인 가격. 부산 서면 렌트카 실시간 예약 가능.',
  },
  vehicles: {
    title: '부산 렌터카 차량 목록 - 예약 가능한 차량',
    description: '부산 렌트카 이용 가능한 차량 목록. 경차부터 SUV까지 다양한 차종 보유. 부산 서면 렌터카 최저가 비교.',
  },
  reservation: {
    title: '부산 렌터카 예약하기 - 간편 예약 시스템',
    description: '부산 렌트카 온라인 예약. 간편한 예약 절차, 안전한 결제. 부산 서면 렌터카 24시간 예약 가능.',
  },
  payment: {
    title: '부산 렌터카 결제 - 안전한 결제 시스템',
    description: '부산 렌트카 안전한 온라인 결제. Toss Payments를 통한 간편 결제. 부산 서면 렌터카 예약 완료.',
  },
  checkReservation: {
    title: '부산 렌터카 예약 확인 - 예약 조회',
    description: '부산 렌트카 예약 내역 조회 및 확인. 예약 번호로 간편 조회. 부산 서면 렌터카 예약 관리.',
  },
  terms: {
    title: '자동차대여 표준약관 - 굿타임 렌터카',
    description: '부산 렌트카 자동차대여 표준약관. 대여계약, 보험, 사고처리 등 렌터카 이용 관련 약관 안내.',
  },
  privacy: {
    title: '개인정보처리방침 - 굿타임 렌터카',
    description: '부산 렌트카 개인정보처리방침. 고객 정보 보호 및 개인정보 처리 관련 정책 안내.',
  },
  rentalGuide: {
    title: '차량안내 - 부산 렌터카 차량 및 가격표',
    description: '부산 렌트카 전체 차량 목록 및 가격 안내. 경차부터 SUV, 승합차까지 다양한 차종과 시간대별 요금 확인.',
  },
  serviceGuide: {
    title: '이용안내 - 부산 렌터카 대여 절차 및 규정',
    description: '부산 렌트카 이용안내. 대여 자격, 절차, 취소 및 환불 규정, 보험 안내 등 렌터카 이용 필수 정보.',
  },
  review: {
    title: '이용후기 작성 - 부산 렌터카',
    description: '부산 렌트카 이용후기 작성. 고객님의 소중한 의견을 들려주세요.',
  },
  reservationDetail: {
    title: '예약 상세정보 - 부산 렌터카',
    description: '부산 렌트카 예약 상세정보 조회. 예약 내역, 차량 정보, 결제 정보 확인.',
  },
  paymentSuccess: {
    title: '결제 완료 - 부산 렌터카',
    description: '부산 렌트카 결제가 성공적으로 완료되었습니다. 예약 정보를 확인해주세요.',
  },
  paymentFail: {
    title: '결제 실패 - 부산 렌터카',
    description: '부산 렌트카 결제가 실패했습니다. 다시 시도해주세요.',
  },
  myCoupons: {
    title: '내 쿠폰 - 부산 렌터카',
    description: '부산 렌트카 보유 쿠폰 조회 및 관리. 할인 쿠폰을 확인하고 예약 시 사용하세요.',
  },
  extensionPaymentSuccess: {
    title: '예약 연장 결제 완료 - 부산 렌터카',
    description: '부산 렌트카 예약 연장 결제가 완료되었습니다.',
  },
} as const;

export const setSEO = (page: keyof typeof pageSEO) => {
  const seo = pageSEO[page];
  document.title = seo.title;
  setPageMeta(seo.description);
  setOgMeta(seo.title, seo.description);
};
